// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"551":"58e9b60144cfc0ea","1196":"f126a06903abdda3","1504":"80e68146575e0cce","2248":"c92d3b743144863b","2541":"e8539b225eb0719e","7327":"227cf772a3935760","8355":"a753dcdd556b1a0e"}[chunkId] + ".css";
};